import { IconButton, Tooltip } from '@mui/material';
import { useColorMode } from '../ThemeContext';
import Icon from '@mdi/react';
import { mdiWeatherNight, mdiWeatherSunny } from '@mdi/js';

const ThemeToggle = () =>{
   const{toggleColorMode, mode} = useColorMode();
    return(
    <Tooltip title={mode === "light" ? "Mode sombre" : "Mode clair"}> 
    <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
    <IconButton
        onClick={toggleColorMode}
        sx={{
        width: "34px",
        height: "34px",
        padding : 0 ,
        color: mode === "light" ? "#555879" : "#747796ff",
        backgroundColor:
            mode === "light"
            ? "rgba(85, 88, 121, 0.1)"
            : "rgba(85, 88, 121, 0.2)",
        "&:hover": {
            backgroundColor:
            mode === "light"
                ? "rgba(85, 88, 121, 0.2)"
                : "rgba(85, 88, 121, 0.2)",
            transition: "background-color 0.3s ease",
            

        },
        transition: "all 0.3s ease",
        }}
    >
        {mode === "light" ? (
        <Icon path={mdiWeatherNight} size={0.8} />
        ) : (
        <Icon path={mdiWeatherSunny} size={0.8} />
        )}
    </IconButton>
    </div>
    </Tooltip>
    )
}
export default ThemeToggle;